import { render, staticRenderFns } from "./WaitListSummary.vue?vue&type=template&id=0e61ace3&scoped=true&"
import script from "./WaitListSummary.vue?vue&type=script&lang=js&"
export * from "./WaitListSummary.vue?vue&type=script&lang=js&"
import style0 from "./WaitListSummary.vue?vue&type=style&index=0&id=0e61ace3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e61ace3",
  null
  
)

export default component.exports